import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Grid,
  Button,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AttendanceCalendar from "./attendanceCalendar";
import dayjs from "dayjs";
import { getAllEmpAttendanceMonth } from "./appoinmentDashboardApi";
import present from "../../assets/present.png";
import halfday from "../../assets/halfday.png";
import absent from "../../assets/absent.png";
import profileIcon from "../../assets/Profile.png";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const EmployeeCalendar = ({ open, onClose, employee }) => {
  const [month, setMonth] = useState(dayjs().month() + 1); // 1-12
  const [year, setYear] = useState(dayjs().year());
  const [monthlyAttendance, setMonthlyAttendance] = useState(
    employee?.monthlyAttendance || {}
  );
  const [summary, setSummary] = useState({
    present: 0,
    absent: 0,
    half: 0,
    totalPresent: 0,
  });

  useEffect(() => {
    if (!employee) return;

    console.log("*******", employee);
    // If no data for this month, fetch from backend
    // if (monthlyAttendance[month]) {
    const payload = {
      employeeId: Number(employee.empId),
      fromMonth: dayjs(`${year}-${month}-01`).format("YYYY-MM-DD"),
    };

    getAllEmpAttendanceMonth(payload, (res) => {
      const rawData = res?.data?.data?.records || [];
      const newMonthData = {};

      rawData.forEach(({ forDate, servedStatus }) => {
        const day = dayjs(forDate).date();
        newMonthData[day] = servedStatus;
      });

      setMonthlyAttendance((prev) => ({
        ...prev,
        [month]: newMonthData,
      }));

      // Optional: store summary counts
      const responseData = res?.data?.data;
      setSummary({
        present: responseData?.presentDays ?? 0,
        absent: responseData?.absentDays ?? 0,
        half: responseData?.halfDays ?? 0,
        totalPresent: responseData?.totalPresentDays ?? 0,
      });
    });
    // }
  }, [open, month]);

  if (!employee) return null;

  const handlePrevMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  const handleNextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src={profileIcon}
            alt="Profile"
            sx={{ width: 36, height: 36 }}
          />
          <Box>
            <Typography fontWeight={700}>{employee.employeeName}</Typography>
            <Typography fontWeight={600}>{employee.employeeId}</Typography>
          </Box>
        </Box>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        {/* Month navigation */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <IconButton onClick={handlePrevMonth}>
            <ChevronLeftIcon />
          </IconButton>

          {/* <Typography fontWeight={700} textAlign="center" flexGrow={1}>
            {dayjs(`${year}-${month}-01`).format("MMMM YYYY")}
          </Typography> */}

          <IconButton onClick={handleNextMonth}>
            <ChevronRightIcon />
          </IconButton>
        </Box>
        {/* Calendar */}
        <AttendanceCalendar
          month={month}
          year={year}
          attendance={monthlyAttendance[month] || {}}
        />
        <Grid
          container
          spacing={2}
          sx={{ mt: 2, justifyContent: "space-between" }}
        >
          {/* <Box sx={{ mt: 2 }}>
            <Typography variant="body2" fontWeight={600}>
              Present: {summary.present} | Absent: {summary.absent} | Half Day:{" "}
              {summary.half}
            </Typography>
            <Typography variant="body2" fontWeight={600} color="primary">
              Total Present Days: {summary.totalPresent}
            </Typography>
          </Box> */}

          {[
            { icon: present, label: "Present", count: summary.present },
            { icon: halfday, label: "Half Day", count: summary.half },
            { icon: absent, label: "Absent", count: summary.absent },
          ].map((item, idx) => (
            <Grid item key={idx}>
              <Box display="flex" justifyContent="center">
                <Typography color="primary" variant="body2" fontWeight={700}>
                  {item.count}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <img src={item.icon} alt={item.label} width={18} height={18} />
                <Typography variant="body2" fontWeight={500}>
                  {item.label}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        <Divider sx={{ bgcolor: "rgba(0, 0, 0, 0.87)", mt: 3 }} />{" "}
        {/* dark divider */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={1}
          px={4}
        >
          <Typography variant="body2" fontWeight={600} color="primary">
            Total Present Days:
          </Typography>
          <Typography variant="body2" fontWeight={700} color="primary">
            {summary.totalPresent}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EmployeeCalendar;
